export const login = {
  'login.title': 'Přihlášení',
  'login.email': 'Uživatel',
  'login.email.required': 'Vyplňte prosím platný e-mail',
  'login.password': 'Heslo',
  'login.email.password': 'Vyplňte prosím platné heslo',
  'login.submit': 'Přihlásit se',
  'login.error': 'Při přihlašování došlo k chybě',
  'login.invalid_credentials': 'Zadaný e-mail nebo heslo je nesprávné',
  'login.logout': 'Odhlášení proběhlo úspěšně',
  'login.login_required': 'Pro přístup je nutné přihlášení',
  'login.session_expired': 'Relace vypršela',
  'login.missing_role': 'Pro přístup nemáte dostatečná oprávnění',
};
